"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TinkoffId = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TinkoffId = function TinkoffId(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.142 0H7.458C3.34 0 0 3.358 0 7.5 0 11.642 3.34 15 7.458 15h12.684c4.119 0 7.458-3.358 7.458-7.5 0-4.142-3.34-7.5-7.458-7.5z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.327 3.856h8.034v4.063a2.92 2.92 0 01-1.45 2.526l-2.567 1.49-2.568-1.49a2.918 2.918 0 01-1.45-2.526V3.856z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.531 5.995v1.263c.172-.195.484-.327.842-.327h.388V8.4c0 .39-.106.732-.263.921h1.689c-.156-.189-.262-.53-.262-.92v-1.47h.388c.358 0 .67.132.842.328V5.996H6.53h.001z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.948 10.048V5.273h-1.497v4.775h1.497zm3.61 0c1.895 0 2.832-1.014 2.832-2.388 0-1.374-.938-2.387-2.673-2.387h-2.673v4.775h2.515-.001zm-.151-3.632c1.028 0 1.456.462 1.456 1.244 0 .723-.427 1.274-1.456 1.274h-.918V6.416h.918z",
    fill: "#fff"
  }));
};

exports.TinkoffId = TinkoffId;
var _default = TinkoffId;
exports.default = _default;